import React from 'react';
import type { AppRunController } from '../appFrame/useAppRunController';
import AppRunApprovals from './AppRunApprovals';
import AppRunSetupBar from './AppRunSetupBar';
import LocalRunStorageNotice from './LocalRunStorageNotice';
import { CLOUD_RUNNER } from './runSetup.constants';

interface AppRunExecutionPanelProps {
  readonly controller: AppRunController;
}

/** Where the run executes and what it is waiting on the person for; empty for an app that only runs in the cloud. */
const AppRunExecutionPanel: React.FC<AppRunExecutionPanelProps> = ({ controller }) => {
  const { run, runSetup, live } = controller;
  const started = Boolean(run && run.status !== 'DRAFT');
  const onTheirComputer = started
    ? Boolean(run?.runner)
    : Boolean(runSetup.selection && runSetup.selection.runner !== CLOUD_RUNNER);

  return (
    <>
      {!started && runSetup.setup && runSetup.selection && (
        <AppRunSetupBar
          setup={runSetup.setup}
          selection={runSetup.selection}
          blocker={runSetup.blocker}
          onSelect={runSetup.select}
          disabled={controller.isBusy}
          approvalLocked={controller.crossOrg}
        />
      )}
      {onTheirComputer && <LocalRunStorageNotice />}
      {run && live.pendingApprovals.length > 0 && (
        <AppRunApprovals
          conversationId={run.conversationId}
          approvals={live.pendingApprovals}
          onSettled={controller.settleApproval}
        />
      )}
    </>
  );
};

export default AppRunExecutionPanel;
